define('controllers/consoleApi/oauth.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('oauthCtrl', ['$q', '$scope', '$location', '$stateParams', '$filter', '$state', 'UserInfo', 'auiDialog', 'UserInfoPreload', 'myServicesPackage', 'OpenApp',
        'payService', 'gameService', 'huaweiIdService', 'OpenGW', 'ngDialog', 'projectManageService', 'opearteShaService', 'biAnalyticService',
        function ($q, $scope, $location, $stateParams, $filter, $state, UserInfo, auiDialog, UserInfoPreload, myServicesPackage, OpenApp, payService,
                  gameService, huaweiIdService, OpenGW, ngDialog, projectManageService, opearteShaService, biAnalyticService) {
            var Model = $scope.Model = {
                projectKey: $stateParams.projectKey,
                projectID: $stateParams.projectID,
                clientID: $stateParams.clientID,
                secureUrlList: angular.copy(mainCons.appConstant.secureUrlList),
                product: {},
                selected: {},
                type: $stateParams.type
            };

            $scope.regexp = mainCons.servicesConstant.regexp;

            // 包名
            Model.showPackageName = mainCons.oauthConstant.showPackageName;
            // 证书指纹
            Model.showFingerPrint = mainCons.oauthConstant.showFingerPrint;

            Model.defaultProductTypeFilterMap = {};
            mainCons.oauthConstant.productTypes.forEach(
                function (t) {
                    Model.defaultProductTypeFilterMap[t.prodType] = t["name"];
                }
            );

            //是否支持服务器应用
            Model.supportServer = false;

            //方法区
            $scope.setProductType = setProductType;

            //提交/取消
            $scope.submit = submit;
            $scope.submitEdit = submitEdit;
            $scope.validOauthRedirectUri = validOauthRedirectUri();
            $scope.validOauthCertFingerprint = validOauthCertFingerprint();
            $scope.checkRepeatFingerprint = checkRepeatFingerprint;
            $scope.checkRepeatBundleId = checkRepeatBundleId;
            $scope.showFingerPrintExam = showFingerPrintExam;
            $scope.validSecurlUrl = validSecurlUrl();
            $scope.validPackageName = validPackageName();
            $scope.getPNSelfTips = getPNSelfTips;
            $scope.validbundleIdUri = validbundleIdUri();
            $scope.validTestBundleIdUri = validTestBundleIdUri();
            $scope.validateWebAppUrl = validateWebAppUrl();
            $scope.contains = contains;

            init();

            function init() {
                if (Model.clientID == 0) {
                    Model.productTypes = mainCons.oauthConstant.productTypes.filter(function (item) {
                        return item.authAdd == true;
                    });
                } else {
                    projectManageService.getProjectCredentialList(Model.projectID).then(function (resp) {
                        if (resp && resp.resultCode == "0") {
                            if (Model.type) {
                                resp.oauthClientInfoList = angular.copy(resp.limitOauthClientInfoList);
                            }
                            if (resp.oauthClientInfoList) {
                                angular.forEach(resp.oauthClientInfoList, function (oauth) {
                                    if (oauth.clientID == Model.clientID) {
                                        oauth.oauthClientAttr.appAttrs && (Model.selected = JSON.parse(oauth.oauthClientAttr.appAttrs));
                                        oauth.oauthClientAttr.appAttrs && (Model.appAttrsCopy = JSON.parse(oauth.oauthClientAttr.appAttrs));
                                        Model.selected.clientID = oauth.clientID;
                                        Model.selected.clientName = oauth.oauthClientAttr.clientName;
                                        Model.selected.appSecret = oauth.appSecret;
                                        Model.selected.prodType = oauth.prodType;
                                        Model.selected.sourceService = oauth.sourceService;
                                        Model.selected.bindAppId = oauth.bindAppId;
                                        Model.selected.oauthRedirectUri && (Model.selected.callbackUrl = Model.selected.oauthRedirectUri);
                                        if (oauth.prodType == '19' && oauth.freeInstallType) {
                                            Model.selected.prodType = Model.selected.prodType + '-' + oauth.freeInstallType;
                                        }
                                        if (oauth.prodType == '19') {//变量替换
                                            Model.selected.prodType = '19-1';
                                            oauth.freeInstallType = 1;
                                            Model.selected.freeInstallType =1;
                                        }
                                        if (oauth.prodType == '16') {//变量替换
                                            Model.selected.prodType = '19-2'
                                            oauth.freeInstallType = 2;
                                            Model.selected.freeInstallType =2;
                                        }
                                        //包名
                                        if (oauth.prodType != 22) {
                                            if ((oauth.prodType == '19' && oauth.freeInstallType == '2') || oauth.prodType == '7') {
                                                Model.selected.webAppUrl = oauth.oauthClientAttr.webAppUrl || '';
                                            } else {
                                                Model.selected.packageName = oauth.oauthClientAttr.packageName || '';
                                                Model.selected.hasPackageName = AUI.BaseJSUtil.existy(Model.selected.packageName);
                                            }
                                        } else {
                                            Model.selected.bundleIdDisable = AUI.BaseJSUtil.existy(Model.selected.bundleId);
                                            Model.selected.testBundleIdDisable = AUI.BaseJSUtil.existy(Model.selected.testBundleId);
                                        }

                                        getFingerPrintInfo();

                                        Model.selected.isUpdate = true;
                                    }
                                });
                            }
                        }
                    });
                }
            }

            //选择产品类型
            function setProductType(productType) {
                if (Model.selected && Model.selected.prodType != productType.prodType) {
                    for (var i in Model.selected) {
                        i != 'prodType' && (Model.selected[i] = "");
                    }
                    Model.selected.prodType = productType.prodType;
                    //免安装应用产品形态1.RPK  2.H5
                    productType.freeInstallType && (Model.selected.freeInstallType = productType.freeInstallType);
                    Model.languageList = productType.languageList;
                    Model.parentType = productType.parentType;
                    Model.languageSelected = Model.languageList[0];
                    Model.parentTypeSelected = Model.parentType[0];
                    $scope.packageForm && $scope.packageForm.$setPristine(true);
                }
            }

            //提交oauth
            function submit() {
                var defer = $q.defer();
                if (!(Model.selected && Model.selected.prodType)) {
                    defer.resolve();
                    auiDialog.warn("请选择产品类型")
                }

                $scope.packageForm.$setDirty();
                if ($scope.packageForm.$invalid) {
                    for (var key in $scope.packageForm) {
                        if (Object.prototype.hasOwnProperty.call($scope.packageForm, key) === true && key.indexOf('$') < 0) {
                            $scope.packageForm[key].$setDirty();
                        }
                    }
                    defer.reject();
                } else {
                    biAnalyticService.bianalyticLink((Model.type == 4 ? "APIConsole - 创建应用级客户端" : "APIConsole - 创建 OAuth 2.0 客户端"), 1, (Model.type == 4 ? "DPRM0083" : "DPRM0073"));
                    UserInfo.promise().then(function () {
                        UserInfo.getAccountBaseInfo().then(function (userInfo) {
                            var prodType = Model.selected.prodType;
                            var params = {
                                req: {
                                    appAbs: {
                                        projectID: Model.projectID,
                                        prodName: Model.product.appName,
                                        defaultLang: Model.languageSelected.key,
                                        parentType: Model.parentTypeSelected.key,
                                        prodType: (prodType == '19-1' || prodType == '19-2') ? 19 : prodType,
                                        createCountry: userInfo.nationalCode||'CN'
                                    },
                                    credentialType: (Model.type ? Model.type : 2)
                                }
                            };
                            //免安装应用产品形态1.RPK  2.H5
                            Model.selected.freeInstallType && (params.req.appAbs.freeInstallType = Model.selected.freeInstallType);

                            prodType = (Model.selected.prodType == '19-1' || Model.selected.prodType == '19-2') ? 19 : Model.selected.prodType;
                            var freeInstallType = Model.selected.freeInstallType;

                            var appAttrs = {};
                            //更新webAppUrl
                            if ($scope.contains(['19-2', '7'], Model.selected.prodType)) {
                                if (Model.selected.webAppUrl) {
                                    params.req.appAbs.webAppUrl = Model.selected.webAppUrl;
                                    appAttrs.webAppUrl = Model.selected.webAppUrl;
                                } else {
                                    params.req.appAbs.webAppUrl = '';
                                    appAttrs.webAppUrl = '';
                                }
                            }
                            //更新packageName
                            Model.selected.packageName && ((params.req.appAbs.packageName = Model.selected.packageName) && (appAttrs.packageName = Model.selected.packageName));
                            //更新bundleId
                            Model.selected.bundleId && ((params.req.appAbs.bundleId = Model.selected.bundleId) && (appAttrs.bundleId = Model.selected.bundleId));
                            //更新testBundleId
                            Model.selected.testBundleId && ((params.req.appAbs.testBundleId = Model.selected.testBundleId) && (appAttrs.testBundleId = Model.selected.testBundleId));
                            // 服务器应用、h5没有指纹
                            if (prodType != 22 && prodType != 7 && !(prodType == 19 && freeInstallType == 2)) {
                                opearteShaService.opearteShaService(appAttrs, angular.copy(Model.selected));
                            }
                            //获取安全 URL
                            if ((Model.accessModeType && Model.accessModeType.length > 1 && Model.accessModeType[1].flag) || (prodType == 19 && freeInstallType == 2)) {
                                appAttrs.secureUrlList = angular.copy(Model.secureUrlList);
                            }
                            //回调地址
                            appAttrs.oauthRedirectUri = Model.selected.callbackUrl || "";
                            params.req.appAttrs = JSON.stringify(appAttrs);


                            projectManageService.addOauth(params.req).then(function (res) {
                                if (res && res.clientID) {
                                    var handle = ngDialog.open({
                                        template: 'pages/consoleApi/oauth/oauth.success.html',
                                        className: '',
                                        controller: ['$scope', function ($scopeDlg) {
                                            $scopeDlg.appID = res.clientID;
                                            $scopeDlg.appSecret = res.appSecret;
                                            $scopeDlg.cancel = function () {
                                                $state.go('credentials', {projectKey: Model.projectKey}, {reload: true});
                                                handle.close();
                                                defer.resolve();
                                            }
                                        }]
                                    });
                                } else {
                                    defer.reject();
                                }
                            }).catch(function () {
                                defer.reject();
                            });
                        })
                    });
                }
                return defer.promise;
            }

            //编辑oauth
            function submitEdit() {
                var defer = $q.defer();
                $scope.packageForm.$setDirty();
                if ($scope.packageForm.$invalid) {
                    for (var key in $scope.packageForm) {
                        if (Object.prototype.hasOwnProperty.call($scope.packageForm, key) === true && key.indexOf('$') < 0) {
                            $scope.packageForm[key].$setDirty();
                        }
                    }
                    defer.reject();
                } else {
                    biAnalyticService.bianalyticLink((Model.type == 4 ? "APIConsole - 修改应用级客户端" : "APIConsole - 修改 OAuth 2.0 客户端"), 1, (Model.type == 4 ? "DPRM0091" : "DPRM0074"));
                    updateAppApi(Model.selected.clientID).then(function () {
                        auiDialog.success("修改成功", function () {
                            $state.go('credentials', {projectKey: Model.projectKey}, {reload: true});
                        });
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }

            //更新产品的appAttr,包括指纹，安全URL，回调地址
            function updateAppApi(appID) {
                var defer = $q.defer();
                var appAbs = {};
                appAbs.prodID = appID;
                var prodType = (Model.selected.prodType == '19-1' || Model.selected.prodType == '19-2') ? 19 : Model.selected.prodType;
                var freeInstallType = Model.selected.freeInstallType;

                var appAttrs = Model.appAttrsCopy ? angular.copy(Model.appAttrsCopy) : {};
                // 服务器应用、h5没有指纹
                if (prodType != 22 && prodType != 7 && !(prodType == 19 && freeInstallType == 2)) {
                    opearteShaService.opearteShaService(appAttrs, angular.copy(Model.selected));
                }
                //获取安全 URL
                if ((Model.accessModeType && Model.accessModeType.length > 1 && Model.accessModeType[1].flag) || (prodType == 19 && freeInstallType == 2)) {
                    appAttrs.secureUrlList = angular.copy(Model.secureUrlList);
                }
                //回调地址
                appAttrs.oauthRedirectUri = Model.selected.callbackUrl || "";
                //更新webAppUrl
                if ($scope.contains(['7'], Model.selected.prodType)) {
                    if (Model.selected.webAppUrl) {
                        appAbs.webAppUrl = Model.selected.webAppUrl;
                        appAttrs.webAppUrl = Model.selected.webAppUrl;
                    } else {
                        appAbs.webAppUrl = '';
                        appAttrs.webAppUrl = '';
                    }
                }
                //更新packageName
                Model.selected.packageName && ((appAbs.packageName = Model.selected.packageName) && (appAttrs.packageName = Model.selected.packageName));
                //更新bundleId
                Model.selected.bundleId && ((appAbs.bundleId = Model.selected.bundleId) && (appAttrs.bundleId = Model.selected.bundleId));
                //更新testBundleId
                Model.selected.testBundleId && ((appAbs.testBundleId = Model.selected.testBundleId) && (appAttrs.testBundleId = Model.selected.testBundleId));
                projectManageService.updateOauth({
                    appAbs: appAbs,
                    appAttrs: JSON.stringify(appAttrs)
                }).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //验证回调地址正则
            function validOauthRedirectUri() {
                var regexp = new RegExp($scope.regexp.oauthRedirectUri);
                return {
                    test: function (value) {
                        //验证是否以http或https开头
                        var regExpErrorX = "回调地址应该以http://或者https://开头";
                        var regExpErrorY = "回调地址不能包含字符'?'";
                        var regExpErrorT = "回调地址不合法，请重新输入。";
                        var regExpErrorP = "，不能包含字符'?'";

                        if (!regexp.test(value)) {
                            $scope.validCallbackUrlText = regExpErrorT;
                            if (value.substring(0, 7) != 'http://' && value.substring(0, 8) != 'https://') {
                                $scope.validCallbackUrlText = regExpErrorX;
                            }
                            if (value.indexOf('?') != -1) {
                                if ($scope.validCallbackUrlText != regExpErrorT) {
                                    $scope.validCallbackUrlText += regExpErrorP;
                                } else {
                                    $scope.validCallbackUrlText = regExpErrorY;
                                }
                            }
                            return false;
                        } else {
                            if (value.indexOf('?') != -1) {
                                $scope.validCallbackUrlText = regExpErrorY;
                                return false;
                            }
                        }
                        return regexp.test(value) && value.substring(value.length - 1) != '\\';
                    }
                }
            }

            //校验指纹证书
            function checkRepeatFingerprint() {
                for (var n = 0; n < 5; n++) {
                    var itemN = n == 0 ? '' : n;
                    if (!$scope.packageForm["oauthCertFingerprint" + itemN]) continue;
                    $scope.packageForm["oauthCertFingerprint" + itemN].$setValidity("repeat", true);
                }
                for (var i = 0; i < 5; i++) {
                    var itemI = i == 0 ? '' : i;
                    for (var j = i + 1; j < 5; j++) {
                        var itemJ = j == 0 ? '' : j;
                        if (!Model.selected["oauthCertFingerprint" + itemI] || !Model.selected["oauthCertFingerprint" + itemJ]) continue;
                        if (AUI.BaseJSUtil.sha2show(Model.selected["oauthCertFingerprint" + itemI].replace(/:/g, "")) ==
                            AUI.BaseJSUtil.sha2show(Model.selected["oauthCertFingerprint" + itemJ].replace(/:/g, ""))) {
                            if (!$scope.packageForm["oauthCertFingerprint" + itemI].$error.pattern) {
                                $scope.packageForm["oauthCertFingerprint" + itemI].$setValidity("repeat", false);
                            }
                            if (!$scope.packageForm["oauthCertFingerprint" + itemJ].$error.pattern) {
                                $scope.packageForm["oauthCertFingerprint" + itemJ].$setValidity("repeat", false);
                            }
                        }
                    }
                }
            }

            //校验指纹证书正则
            function validOauthCertFingerprint() {
                return {
                    test: function (value) {
                        return checkParams(value, $scope.regexp.oauthCertFingerprint);
                    }
                }
            }

            function checkParams(str, reg) {
                if (str == '') {
                    return true;
                }
                //rpk 的sha256签名校验
                if (Model.selected.prodType == '19-1' || Model.selected.prodType == '23' || Model.selected.prodType == '28' || Model.selected.prodType == '42') {
                    var regForRpk = $scope.regexp.oauthCertFingerprintForRpk;
                    return (new RegExp(regForRpk)).test(str) && str.length;
                } else if (Model.selected.prodType == '41') {
                    return true;
                } else {//非rpk 的sha256签名校验
                    return (new RegExp(reg)).test(str);
                }
            }


            function getFingerPrintInfo() {
                var prodType = Model.selected.prodType;
                if (prodType != "22" && AUI.BaseJSUtil.existy(Model.selected.oauthCertFingerprint)) {
                    //免安装应用-rpk sha256指纹比较特别
                    Model.selected.oauthCertFingerprint = (prodType == '42' ||prodType == '28' || prodType == '23' || prodType == '19-1')
                        ? Model.selected.oauthCertFingerprint : (prodType == '41' ? Model.selected.oauthCertFingerprint : AUI.BaseJSUtil.sha2show(Model.selected.oauthCertFingerprint));
                }

                if (prodType != "22" && prodType != "19-1" && prodType != "19-2" && prodType != "23" && prodType != "28" && prodType != "42") {
                    if (AUI.BaseJSUtil.existy(Model.selected.certFingerprintExtra) && typeof Model.selected.certFingerprintExtra == 'string') {
                        var certFingerprintExtraTempDel = Model.selected.certFingerprintExtra.split(';');
                        if (certFingerprintExtraTempDel.length > 0) {
                            for (var h = 0; h < certFingerprintExtraTempDel.length; h++) {
                                Model.selected['oauthCertFingerprint' + (h + 1)] = (prodType == '41' ? certFingerprintExtraTempDel[h] : AUI.BaseJSUtil.sha2show(certFingerprintExtraTempDel[h]));
                            }
                        }
                    }
                }
            }

            // 指纹示例
            function showFingerPrintExam() {
                //免安装应用-rpk sha256指纹比较特别
                return (Model.selected.prodType == "19-1" || Model.selected.prodType == "23" || Model.selected.prodType == "28" || Model.selected.prodType == "42") ?
                    '59d55fa3eefdac5425ada6a8ee005f777c3cbe01c8b4a7028cc635ea3532f78d'
                    : (Model.selected.prodType == '41' ? systemParaConf.fingerPrintExamForPC : '8B:3C:0D:0C:32:90:7B:7B:5E:F8:C3:9C:EF:D0:A4:0D:15:4B:DE:C4:C4:A7:25:A6:0B:A7:2A:7B:32:6C:70:DA');
            }

            //验证安全URL
            function validSecurlUrl() {
                return {
                    test: function (value) {
                        return (new RegExp($scope.regexp.secureUrl)).test(value);
                    }
                }
            }

            //验证包名
            function validPackageName() {
                return {
                    test: function (value) {
                        return (new RegExp($scope.regexp.packageName)).test(value);
                    }
                }
            }

            /**
             * 包名自定义弹框错误提示
             * @returns {*}
             */
            function getPNSelfTips() {
                if ($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.required) {
                    return "请输入包名";
                } else if ($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.pattern) {
                    return "应用包名格式错误";
                } else if ($scope.packageForm.packageName.$dirty && $scope.packageForm.packageName.$error.minlength && !$scope.packageForm.packageName.$error.pattern) {
                    return "包名长度不能少于4个字符";
                }
                return "";
            }

            function validbundleIdUri() {
                var regexp = new RegExp($scope.regexp.bundleId);
                return {
                    test: function (value) {
                        if (!regexp.test(value)) {
                            $scope.validbundleIdText = "不可以包含除 字母，数字，“ .  -  _ ” 以外的其他内容";
                            return regexp.test(value);
                        } else {
                            $scope.validbundleIdText = "";
                            return regexp.test(value);
                        }
                    }
                }
            }

            function validTestBundleIdUri() {
                var regexp = new RegExp($scope.regexp.bundleId);
                return {
                    test: function (value) {
                        if (!regexp.test(value)) {
                            $scope.validTestBundleIdText = "不可以包含除 字母，数字，“ .  -  _ ” 以外的其他内容";
                            return regexp.test(value);
                        } else {
                            $scope.validTestBundleIdText = "";
                            return regexp.test(value);
                        }
                    }
                }
            }

            function checkRepeatBundleId() {
                if (Model.selected.testBundleId && Model.selected.bundleId && Model.selected.testBundleId.toLowerCase() == Model.selected.bundleId.toLowerCase()) {
                    $scope.packageForm["bundleId"].$setValidity("repeat", false);
                    $scope.packageForm["testBundleId"].$setValidity("repeat", false);
                    $scope.validTestBundleIdText = "测试Bundleid不可以和Bundleid相同";
                } else {
                    $scope.packageForm["bundleId"].$setValidity("repeat", true);
                    $scope.packageForm["testBundleId"].$setValidity("repeat", true);
                }
            }

            //包含
            function contains(arr, obj) {
                return AUI.BaseJSUtil.contains(arr, obj);
            }

            //校验应用访问地址
            function validateWebAppUrl() {
                return {
                    test: function (webAppUrl) {
                        webAppUrl = webAppUrl || '';
                        if (webAppUrl.indexOf('*') >= 0) {
                            return false;
                        }
                        return !(!AUI.BaseJSUtil.checkUrl(webAppUrl) || webAppUrl == '');
                    }
                };
            }
        }]);
});

